<template>
  <div class="range" role="group" aria-label="Time range">
    <button
      v-for="r in ranges"
      :key="r"
      class="range-btn"
      :class="{ active: r === modelValue }"
      :aria-pressed="r === modelValue"
      :title="RANGE_LABEL[r]"
      @click="$emit('update:modelValue', r)"
    >
      {{ r }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { TIME_RANGES, RANGE_LABEL, type TimeRange } from '../composables/useFilters.js';

defineProps<{ modelValue: TimeRange }>();
defineEmits<{ 'update:modelValue': [value: TimeRange] }>();

const ranges = TIME_RANGES;
</script>

<style scoped>
.range {
  display: inline-flex;
  border: 1px solid var(--lg-border-strong);
  border-radius: var(--lg-radius-md);
  overflow: hidden;
}
.range-btn {
  font: inherit;
  font-size: var(--lg-fs-sm);
  font-family: var(--lg-font-mono);
  min-height: var(--lg-control-md);
  padding: 0 var(--lg-space-3);
  background: var(--lg-bg-surface);
  color: var(--lg-text-dim);
  border: none;
  border-right: 1px solid var(--lg-border);
  cursor: pointer;
}
.range-btn:last-child {
  border-right: none;
}
.range-btn:hover {
  color: var(--lg-text);
}
.range-btn.active {
  background: var(--lg-accent);
  color: var(--lg-accent-fg);
  font-weight: 600;
}
.range-btn:focus-visible {
  outline: none;
  box-shadow: inset 0 0 0 2px var(--lg-accent);
}
</style>
